export type PaymentServiceInitPayload = Record<string, never>;

export type SEPAMandateInfo = {
  /**
   * Name on account
   */
  name: string;
  /**
   * Email Address
   */
  email: string;
  /**
   * IBAN Number
   */
  IBAN: string;
};

export enum PaymentServiceMandateStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  PROCESSING = 'processing',
}

export enum PaymentServiceMandateType {
  MULTI_USER = 'multi_use',
  SINGLE_USE = 'single_use',
  CARD = 'card',
}

export enum PaymentServiceCustomerType {
  BRAND = 'brand',
  RETAILER = 'retailer',
}

export type PaymentServiceProviderCustomer = {
  aksCustomerId: string;
  aksCustomerType: PaymentServiceCustomerType;
  customerId: string;
  setupIntentId: string;
  paymentServiceProvider: string;
  email: string;
  description: string;
  name: string;
  mandateType: PaymentServiceMandateType;
  mandateStatus: PaymentServiceMandateStatus;
};

export type SetupIntent = {
  clientSecret: string;
  ibanLast4: string;
};

export type CardSetupIntent = {
  clientSecret: string;
  cardDetails: null | CardDetails;
};

export type CardDetails = {
  brand: string;
  last4: string;
  expMonth: string;
  expYear: string;
};
